import { Card, CardBody, Col, Container, Form, Row } from "reactstrap";
import { Breadcrumbs, Btn } from "../../../../AbstractElements";
import { AddPostTitle, Blog, Discard, Post, PostEditTitle } from "../../../../Constants/Constants";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import CommonFileUpload from "../../../CommonComponents/CommonFileUpload";
import PostEditForm from "./PostEditForm";
const AddPostContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={AddPostTitle} parent={Blog} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card className="single-dropzone">
              <CommonCardHeader title={PostEditTitle} />
              <CardBody className="add-post">
                <PostEditForm />
                <Form className="add-primary-post m-b-20">
                  <CommonFileUpload />
                </Form>
                <div className="btn-showcase text-end">
                  <Btn color="primary">{Post}</Btn>
                  <Btn color="light">{Discard}</Btn>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};
export default AddPostContainer;
